// @flow

import * as React from 'react';
import { Flex, Box, useSystem } from 'react-system';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { useTheme } from '../theme';
import { useLocale } from '../hooks/locale.js';
import { Center } from '../controls/Center.js';
import { Link } from '../controls/link';
import { Hero } from '../controls/hero.js';
import { SectionHeading } from '../controls/section-heading.js';

const Subheading = ({ children }) => {
  const { mb } = useSystem();
  const { text } = useTheme();
  return <h3 css={[text.h5, mb(4)]}>{children}</h3>;
};

const Question = ({ children }) => {
  const { mb, media } = useSystem();
  const { text } = useTheme();
  return <p css={[media([text.body2, text.body1]), mb(1)]}>{children}</p>;
};

type Props = {|
  noBackgroundImage?: boolean,
|};

export const RedOrBluePillSection = (props: Props): React.Node => {
  const { t } = useLocale();
  const { px, py, pt, pb, media } = useSystem();

  const absolute = (top, bottom, right, left) => ({
    position: 'absolute',
    top,
    bottom,
    right,
    left,
  });
  const maxWidth = value => ({ maxWidth: value });
  const textAlign = value => ({ textAlign: value });

  return (
    <Hero
      file={
        props.noBackgroundImage === true
          ? null
          : {
              bucketName: 'aggregator-images2',
              fileName: 'red-or-blue-pill-bg.png',
            }
      }
      objectPosition={'bottom left'}
    >
      <Box
        css={[
          absolute(0, 0, 0, 0),
          media({
            backgroundPosition: 'center-bottom',
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
            backgroundImage: [
              'linear-gradient(to top, rgba(255, 255, 255, 0.001), white,white, white, white)',
              'linear-gradient(to top, rgba(255, 255, 255, 0.001), white)',
            ],
          }),
        ]}
      />

      <Center css={[pt(6), pb(5), { position: 'relative' }]}>
        <SectionHeading align="center">
          {t('redOrbluePillTitle')}
        </SectionHeading>
        <Flex flexWrap="wrap" justifyContent="center">
          <Box width={[1, 1 / 2]} px={[0, 3]} mb={5} css={maxWidth(480)}>
            <Paper elevation={20} css={[py(4), px(4)]}>
              <Box mb={4} css={textAlign('center')}>
                <Subheading>{t('sellBetter')}</Subheading>
                <Question>{t('sellBetterQuestion1')}</Question>
                <Question>{t('sellBetterQuestion2')}</Question>
                <Question>{t('sellBetterQuestion3')}</Question>
              </Box>
              <Link
                href={{
                  pathname: `/appraisal`,
                }}
              >
                <Button component="a" color="primary">
                  {t('sellBetterAppraiseHome')}
                </Button>
              </Link>
            </Paper>
          </Box>
        </Flex>
      </Center>
    </Hero>
  );
};
